(function(){
  // Initialize all hero media sections on the page
  function initializeHeroMediaSections() {
    const sections = document.querySelectorAll('.mt-hero-media-section');
    
    sections.forEach(section => {
      const sectionId = section.id.replace('mt-hero-media-', '');
      const desktopVideo = document.getElementById(`mt-desktop-video-${sectionId}`);
      const mobileVideo = document.getElementById(`mt-mobile-video-${sectionId}`);
      const ctrl = document.getElementById(`mt-media-control-${sectionId}`);
      const btn = document.getElementById(`mt-toggle-play-${sectionId}`);
      
      if (!ctrl || !btn) return;
      
      function canShowControl(videoEl) {
        if(!videoEl) return false;
        // if video has autoplay attribute we hide the control (autoplay muted)
        if (videoEl.hasAttribute('autoplay')) { return false; }
        return true;
      }

      // Decide which video to attach control to depending on viewport
      function pickVideo() {
        if (window.innerWidth >= 768) {
          return desktopVideo;
        } else {
          return mobileVideo;
        }
      }

      function updateControlVisibility() {
        const v = pickVideo();
        if (canShowControl(v)) {
          ctrl.style.display = 'block';
        } else {
          ctrl.style.display = 'none';
        }
      }

      // Toggle play/pause
      btn.addEventListener('click', function(){
        const v = pickVideo();
        if(!v) return;
        if (v.paused) {
          v.play();
          btn.textContent = '❚❚';
          btn.setAttribute('aria-pressed','true');
        } else {
          v.pause();
          btn.textContent = '▶︎';
          btn.setAttribute('aria-pressed','false');
        }
      });

      // Update control on resize (mobile/desktop switch)
      window.addEventListener('resize', updateControlVisibility);
      updateControlVisibility();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHeroMediaSections);
  } else {
    initializeHeroMediaSections();
  }
})();